<template>
    <section class="getting-started">
        <div class="getting-started-layout">
            <div class="bento-column">
                <div class="bento-grid">
                    <div
                        class="bento-block"
                        v-for="(step, index) in steps"
                        :key="index"
                        :class="{ active: activeStep === index, done: index < activeStep }"
                        @click="handleBlockClick(index)">
                        <div class="bento-fill" :style="{ width: fillWidth(index) }"></div>
                        <div class="bento-content">
                            <span class="bento-label">
                                <b-icon :icon="step.icon" pack="fas" size="is-small" class="bento-icon" />
                                {{ step.label }}
                            </span>
                            <p class="bento-text">{{ step.text }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mockup-column">
                <div class="onboarding-discord-wrapper">
                    <Discord :channel="steps[activeStep].channel" class="onboarding-discord">
                        <transition name="mockup-fade" mode="out-in">
                            <div class="discord-mockup-content" :key="activeStep">

                        <template v-if="steps[activeStep].id === 'invite'">
                            <DiscordMessage
                                username="Gamebot"
                                bot
                                role-color="#52d9e9"
                                :avatar="require('@/assets/images/brand/64w/pfp.png')"
                                avatarExtension=".webp">
                                <DiscordMessageEmbed color="#52d9e9" title="Gamebot joined the server!">
                                    Thanks for the invite! Type <b>/help</b> anytime to get started, or <b>/gamelist</b> to see what you can play.
                                </DiscordMessageEmbed>
                            </DiscordMessage>
                        </template>

                        <template v-else-if="steps[activeStep].id === 'choose'">
                            <DiscordMessage
                                username="you"
                                role-color="#febaca"
                                :avatar="require('@/assets/images/mockup/person.jpeg')"
                                avatarExtension=".webp">
                                /gamelist
                            </DiscordMessage>
                            <DiscordMessage
                                username="Gamebot"
                                bot
                                role-color="#52d9e9"
                                :avatar="require('@/assets/images/brand/64w/pfp.png')"
                                avatarExtension=".webp">
                                <DiscordMessageEmbed color="#52d9e9" title="List of available games" footer="Type /info <game id> to see how to play.">
                                    <b>1. Anagrams</b> &middot; <code>ana</code><br>
                                    <b>2. Cards Against Humanity</b> &middot; <code>cah</code><br>
                                    <b>3. CAH: Family Edition</b> &middot; <code>caf</code><br>
                                    <b>4. Chess</b> &middot; <code>che</code><br>
                                    <b>5. Connect 4</b> &middot; <code>c4</code><br>
                                    <b>6. Othello</b> &middot; <code>oth</code><br>
                                    <b>7. Poker</b> &middot; <code>pok</code><br>
                                    <b>8. Survey Says</b> &middot; <code>sus</code><br>
                                    <b>9. Wisecracks</b> &middot; <code>wis</code>
                                </DiscordMessageEmbed>
                            </DiscordMessage>
                        </template>

                        <template v-else-if="steps[activeStep].id === 'start'">
                            <DiscordMessage
                                username="you"
                                role-color="#febaca"
                                :avatar="require('@/assets/images/mockup/person.jpeg')"
                                avatarExtension=".webp">
                                /play
                            </DiscordMessage>
                            <DiscordMessage
                                username="Gamebot"
                                bot
                                role-color="#52d9e9"
                                :avatar="require('@/assets/images/brand/64w/pfp.png')"
                                avatarExtension=".webp">
                                <DiscordMessageEmbed color="#52d9e9" title="Which game do you want to play?">
                                    Pass a game ID, like <b>/play ana</b>, or run <b>/gamelist</b> to browse everything first.
                                </DiscordMessageEmbed>
                            </DiscordMessage>
                        </template>

                        <template v-else-if="steps[activeStep].id === 'play'">
                            <DiscordMessage
                                username="Gamebot"
                                bot
                                role-color="#52d9e9"
                                :avatar="require('@/assets/images/brand/64w/pfp.png')"
                                avatarExtension=".webp">
                                <DiscordMessageEmbed color="#52d9e9" title="Anagrams">
                                    The letters are: <b>S H B I G G I</b>
                                </DiscordMessageEmbed>
                            </DiscordMessage>
                            <DiscordMessage
                                username="a rubber duck"
                                role-color="#f9df48"
                                :avatar="require('@/assets/images/mockup/duck.jpg')"
                                avatarExtension=".webp">
                                big
                            </DiscordMessage>
                            <DiscordMessage
                                username="a rubber duck"
                                role-color="#f9df48"
                                :avatar="require('@/assets/images/mockup/duck.jpg')"
                                avatarExtension=".webp">
                                ish
                            </DiscordMessage>
                            <DiscordMessage
                                username="Gamebot"
                                bot
                                role-color="#52d9e9"
                                :avatar="require('@/assets/images/brand/64w/pfp.png')"
                                avatarExtension=".webp">
                                <DiscordMessageEmbed color="#52d9e9" title="The game is over!">
                                    <b>a rubber duck</b> got <b>BIG, ISH</b> for <b>100 points</b>!<br>
                                    The pangram was <b>BIGGISH</b>.
                                </DiscordMessageEmbed>
                            </DiscordMessage>
                        </template>

                        <template v-else>
                            <DiscordMessage
                                username="you"
                                role-color="#febaca"
                                :avatar="require('@/assets/images/mockup/person.jpeg')"
                                avatarExtension=".webp">
                                /profile
                            </DiscordMessage>
                            <DiscordMessage
                                username="Gamebot"
                                bot
                                role-color="#52d9e9"
                                :avatar="require('@/assets/images/brand/64w/pfp.png')"
                                avatarExtension=".webp">
                                <DiscordMessageEmbed color="#38863f" title="you's Profile">
                                    <b>Level 1</b><br>
                                    <code>▓░░░░░░░░░░░  120 / 1,000 XP</code><br>
                                    🎮 <b>1</b> game played &middot; 🏆 <b>1</b> win<br>
                                    ✅ Play your first game (+50 XP)
                                </DiscordMessageEmbed>
                            </DiscordMessage>
                        </template>

                            </div>
                        </transition>
                    </Discord>
                </div>

                <div class="step-dots">
                    <span
                        class="step-dot"
                        v-for="(step, index) in steps"
                        :key="index"
                        :class="{ active: activeStep === index }"></span>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.getting-started {
    max-width: 920px;
    margin: 0 auto;
    text-align: left;
}

.getting-started-layout {
    display: flex;
    flex-direction: column;
    gap: 20px;

    @include desktop {
        flex-direction: row;
        align-items: center;
    }
}

.bento-column {
    min-width: 0;
    // On tablet/mobile the mockup leads and the active step's caption sits
    // underneath it; on desktop they sit side by side in DOM order.
    order: 2;

    @include desktop {
        flex: 1 1 auto;
        order: 0;
    }
}

.mockup-column {
    order: 1;

    @include desktop {
        flex: 0 0 440px;
        order: 0;
    }
}

.bento-grid {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.bento-block {
    position: relative;
    width: 100%;
    background: $light;
    border-radius: 14px;
    overflow: hidden;
    cursor: pointer;
    padding: 22px 26px;

    // Only show the active step's caption on tablet/mobile, underneath the mockup.
    @include touch {
        display: none;

        &.active {
            display: block;
        }
    }
}

.bento-fill {
    position: absolute;
    inset: 0;
    width: 0%;
    background: darken($light, 4%);
    z-index: 0;
}

.bento-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: $gray;
}

.bento-label {
    display: flex;
    align-items: center;
    gap: 18px;
    font-weight: bold;
    font-size: 1.35rem;
    color: $gray;
    line-height: 1.25;
}

.bento-icon.icon {
    color: $gray;
    font-size: 1rem;
    width: auto;
    height: auto;
    display: inline-flex;
    align-items: center;
}

.bento-text {
    display: none;
    margin-top: 16px;
    font-size: 0.95rem;
    color: $gray;
    line-height: 1.5;

    .active & {
        display: block;
    }
}

.onboarding-discord-wrapper {
    display: flex;
    justify-content: center;
}

.onboarding-discord {
    max-width: 440px;
    width: 100%;

    // Fixed-height message area, sized to the tallest step's content. Anchoring
    // to the bottom means shorter steps show blank space up top (like a chat
    // scrolled to the latest message) instead of the taller steps getting cut
    // off, and overflow from a too-tall step clips from the top instead of
    // pushing the panel's chrome (input bar, footer) further down the page.
    ::v-deep .discord-body {
        height: 340px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }
}

.mockup-fade-enter-active, .mockup-fade-leave-active {
    transition: opacity 0.25s;
}
.mockup-fade-enter, .mockup-fade-leave-to {
    opacity: 0;
}

.step-dots {
    display: none;
    justify-content: center;
    gap: 8px;
    margin-top: 14px;

    @include touch {
        display: flex;
    }

    @include desktop {
        display: none;
    }
}

.step-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: $gray-light;
    transition: background 0.2s;

    &.active {
        background: $gray-dark;
    }
}
</style>

<script>
import Discord from '@/components/Discord/Discord.vue'
import DiscordMessage from '@/components/Discord/DiscordMessage.vue'
import DiscordMessageEmbed from '@/components/Discord/DiscordMessageEmbed.vue'

const STEP_DURATION = 4500

export default {
    name: 'GettingStarted',
    components: {
        Discord,
        DiscordMessage,
        DiscordMessageEmbed,
    },
    data() {
        return {
            activeStep: 0,
            progress: 0,
            elapsedMs: 0,
            lastFrameTime: null,
            rafId: null,
            steps: [
                { id: 'invite', label: 'Invite', icon: 'user-plus', channel: 'welcome', text: 'Add Gamebot to a server you manage. It just works.' },
                { id: 'choose', label: 'Choose', icon: 'search', channel: 'general', text: 'Browse /gamelist, then check /info for the rules.' },
                { id: 'start', label: 'Start', icon: 'play', channel: 'general', text: 'Type /play in any channel to start a game.' },
                { id: 'play', label: 'Play', icon: 'gamepad', channel: 'ana', text: "A full round plays out, right in the channel." },
                { id: 'levelup', label: 'Level Up', icon: 'chart-line', channel: 'general', text: 'Every game earns XP toward your level.' },
            ],
        }
    },
    methods: {
        fillWidth(index) {
            if (index === this.activeStep) return `${this.progress}%`
            return index < this.activeStep ? '100%' : '0%'
        },
        goToStep(index) {
            this.activeStep = index
            this.progress = 0
            this.elapsedMs = 0
            this.lastFrameTime = null
        },
        handleBlockClick(index) {
            // On tablet/mobile only the active block is visible, so tapping it
            // (rather than a re-click that would be a no-op) advances to the next step.
            if (index === this.activeStep) {
                this.goToStep((this.activeStep + 1) % this.steps.length)
            } else {
                this.goToStep(index)
            }
        },
        loop(timestamp) {
            if (this.lastFrameTime === null) this.lastFrameTime = timestamp
            const delta = timestamp - this.lastFrameTime
            this.lastFrameTime = timestamp

            this.elapsedMs += delta
            this.progress = Math.min(100, (this.elapsedMs / STEP_DURATION) * 100)

            if (this.elapsedMs >= STEP_DURATION) {
                this.goToStep((this.activeStep + 1) % this.steps.length)
            }

            this.rafId = requestAnimationFrame(this.loop)
        },
    },
    mounted() {
        this.rafId = requestAnimationFrame(this.loop)
    },
    beforeDestroy() {
        if (this.rafId) cancelAnimationFrame(this.rafId)
    },
}
</script>
